import { useState } from 'react'

import { PhnxSubscribeForm } from '@/components/03-organisms/SubscribeForm/SubscribeForm'

import styles from './Forminput.module.css'

export type ForminputProps = {
  variant: 'text' | 'email' | 'number' | 'radio' | 'checkbox' | 'textarea' | 'hidden' | 'subscribe'
  lineHeight?: number
  name: string
  label?: string
  placeholder?: string
  hiddenValue?: string
  isRequired?: boolean
  showRequired?: boolean
  radioOptions?: string[]
  customAnswer?: string
  onChange?: (value: string) => void
  value?: string
  checked?: boolean
}

export const PhnxForminput: React.FC<ForminputProps> = ({
  variant = 'text',
  lineHeight = 80,
  name,
  label,
  placeholder,
  hiddenValue,
  isRequired = false,
  showRequired = true,
  radioOptions,
  customAnswer,
  onChange,
  value,
  checked,
}) => {
  const textAreaHeight = String(lineHeight + 'px')

  const checkboxStyle = `
    ${styles['PhnxFormInput']}
    ${styles[`input-${variant}`]}
  `.trim()

  const [radioSelected, setRadioSelected] = useState<string | null>(null)

  return (
    <div className={checkboxStyle}>
      {variant === 'hidden' ? (
        <input
          type="hidden"
          id={name}
          name={name}
          value={value || hiddenValue || ''}
          className={styles.reallyhiddenFormElement}
        />
      ) : (
        variant !== 'radio' && (
          <label htmlFor={name} className={styles[`${label ? 'form-label' : 'sr-only'}`]}>
            {label ? label : placeholder ? placeholder : 'Enter your response here'}
            {isRequired && showRequired && '*'}
          </label>
        )
      )}
      {variant === 'text' && (
        <input
          type="text"
          id={name}
          name={name}
          required={isRequired}
          placeholder={placeholder && placeholder}
          data-customan={customAnswer}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
        />
      )}
      {variant === 'textarea' && (
        <textarea
          id={name}
          name={name}
          required={isRequired}
          placeholder={placeholder && placeholder}
          data-customan={customAnswer}
          style={{ height: textAreaHeight }} // Correct property name
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value}
        />
      )}
      {variant === 'email' && (
        <input
          type="email"
          id={name}
          name={name}
          required={isRequired}
          placeholder={placeholder && placeholder}
          data-customan={customAnswer}
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value}
        />
      )}
      {variant === 'number' && (
        <input
          type="number"
          id={name}
          name={name}
          required={isRequired}
          placeholder={placeholder && placeholder}
          data-customan={customAnswer}
          onChange={(e) => onChange && onChange(e.target.value)}
          value={value}
        />
      )}
      {variant === 'checkbox' && (
        <input
          type="checkbox"
          id={name}
          name={name}
          required={isRequired}
          className={styles['form-checkbox']}
          data-customan={customAnswer}
          onChange={(e) => onChange && onChange(e.target.value)}
          checked={checked ?? false}
        />
      )}
      {variant === 'radio' && (
        <fieldset>
          <legend className={styles['form-title']}>
            {label && label} {isRequired && showRequired && '*'}
          </legend>
          <div className={styles['form-radiolayout']}>
            {radioOptions && Array.isArray(radioOptions) && radioOptions.length > 0 ? (
              radioOptions?.map((option) => (
                <div key={option} className={styles['form-radio']}>
                  <input
                    id={`${name}-${option}`}
                    name={name}
                    type="radio"
                    value={option}
                    required
                    onChange={(e) => {
                      if (onChange) {
                        onChange(e.target.value)
                      }
                      setRadioSelected(option)
                    }}
                    checked={radioSelected === option ? true : false}
                  />
                  <label htmlFor={`${name}-${option}`} className={styles['custom-radio']}>
                    {option}
                  </label>
                </div>
              ))
            ) : (
              <>
                <div className={styles['form-radio']}>
                  <input
                    id={`${name}-yes`}
                    name={name}
                    type="radio"
                    value="yes"
                    required
                    data-customan={customAnswer}
                    onChange={(e) => {
                      if (onChange) {
                        onChange(e.target.value)
                      }
                      setRadioSelected('yes')
                    }}
                    checked={radioSelected === 'yes' ? true : false}
                  />
                  <label htmlFor={`${name}-yes`} className={styles['custom-radio']}>
                    Yes
                  </label>
                </div>
                <div className={styles['form-radio']}>
                  <input
                    id={`${name}-no`}
                    name={name}
                    type="radio"
                    value="no"
                    required
                    data-customan={customAnswer}
                    onChange={(e) => {
                      if (onChange) {
                        onChange(e.target.value)
                      }
                      setRadioSelected('no')
                    }}
                    checked={radioSelected === 'no' ? true : false}
                  />
                  <label htmlFor={`${name}-no`} className={styles['custom-radio']}>
                    No
                  </label>
                </div>
              </>
            )}
          </div>
        </fieldset>
      )}
      {variant === 'subscribe' && <PhnxSubscribeForm placeholder={placeholder} />}
    </div>
  )
}
